import React, { useState } from 'react';
import Diet from './Diet';
import Condition from './Condition';
import DeviceStatusForm from '../DeviceStatusForm';

const Tabs = ({ patientId, selectedDate, deviceStatusId }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isListView, setIsListView] = useState(true);

  // 탭 클릭 시 화면 전환을 함께 처리
  const handleTabClick = (index) => {
    setActiveTab(index);
    if (index === 2) { // 기기 상태 탭을 클릭했을 때
      setIsListView(!isListView); // 뷰 전환
    }
  };

  const tabs = [
    { label: '건강 상태', component: <Condition patientId={patientId} selectedDate={selectedDate} /> },
    { 
      label: '기기 상태', component: <DeviceStatusForm patientId={patientId} deviceStatusId={deviceStatusId} /> 
      // 뷰에 따른 탭 라벨
    },
    { label: '식단', component: <Diet patientId={patientId} selectedDate={selectedDate} /> },

  ];

  return (
    <div style={{ 
      height: '100%', 
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    }}>
      <div style={{
        display: 'flex',
        gap: '8px',
        padding: '16px 16px 0',
        borderBottom: '1px solid #e5e7eb',
        backgroundColor: '#f9fafb'
      }}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => handleTabClick(index)}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '6px 6px 0 0',
              backgroundColor: activeTab === index ? '#fff' : 'transparent',
              color: activeTab === index ? '#2563eb' : '#6b7280',
              fontWeight: activeTab === index ? '600' : '500',
              fontSize: '0.875rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              position: 'relative',
              bottom: activeTab === index ? '-1px' : '0',
              borderTop: activeTab === index ? '2px solid #2563eb' : 'none',
              borderLeft: activeTab === index ? '1px solid #e5e7eb' : 'none',
              borderRight: activeTab === index ? '1px solid #e5e7eb' : 'none',
              ':hover': {
                backgroundColor: activeTab === index ? '#fff' : '#f3f4f6'
              },
              ':focus': {
                outline: 'none',
                boxShadow: '0 0 0 2px rgba(37, 99, 235, 0.2)'
              }
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div style={{ 
        flex: 1,
        overflow: 'auto',
        padding: '16px',
        backgroundColor: '#fff'
      }}>
        {tabs[activeTab].component}
      </div>
    </div>
  );
};

export default Tabs;
